import api from './axios';

export const listar = (params = {}) => api.get('/auditoria/', { params });
export const estatisticas = (dias = 30) => api.get('/auditoria/estatisticas', { params: { dias } });
export const purgarEventos = () => api.post('/auditoria/purgar-eventos');
